/**
 * Entry Node Fields
 *
 * Properties panel fields for entry nodes (informational only).
 */

export function EntryNodeFields() {
  return (
    <div className="text-sm text-muted-foreground">
      <p>This is the starting point of your flow.</p>
      <p className="mt-2">Trigger keywords are set in the toolbar above.</p>
    </div>
  );
}
